import apiService from "../../api/api.service";
import { NotFoundResponse } from "./notFound.types";

export const fetchNotFoundData = (slug: string) => {
  return apiService.get<NotFoundResponse>(`/general/not-found/${slug}`);
};
